export default function getStartFromPosition({
  ignoreStreamPosition,
  position,
  playFromPosition,
  liveSeekStreamPosition,
}) {
  let startFromPosition = 0;
  if (!ignoreStreamPosition) {
    startFromPosition = position;
  }
  if (playFromPosition) {
    startFromPosition = playFromPosition;
  }
  if (liveSeekStreamPosition) {
    startFromPosition = liveSeekStreamPosition;
  }
  return startFromPosition;
}
